import { IonToast } from './styled'

type Notification = {
  id: UniqueId
  title: string
  description: string
  actions?: () => void
}

type NotificationProps = {
  onNotificationsOpen: () => void
  onClose: (notification: Notification) => void
  isShow: boolean
  notification?: Notification
}

export function Notification({
  onNotificationsOpen,
  isShow,
  onClose,
  notification,
}: NotificationProps) {
  const handleOnClose = () => onClose(notification as Notification)

  const handleNotificationsOpen = () => {
    handleOnClose()
    const fn = notification?.actions || onNotificationsOpen
    fn?.()
  }

  return (
    <IonToast
      isOpen={isShow}
      header={notification?.title}
      message={notification?.description}
      position='top'
      layout='stacked'
      swipeGesture='vertical'
      buttons={[
        {
          text: 'Подробнее',
          handler: handleNotificationsOpen,
        },
        {
          text: 'Скрыть',
          handler: handleOnClose,
          role: 'cancel',
        },
      ]}
    />
  )
}
